var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post"},[_c('post-header',{attrs:{"post":_vm.post}}),_c('post-body',{attrs:{"post":_vm.post}}),_c('post-footer',{attrs:{"post":_vm.post}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }